var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#0F6CBD",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99983 9.33412C8.73647 9.33412 9.33363 8.73696 9.33363 8.00031C9.33363 7.26367 8.73647 6.6665 7.99983 6.6665C7.26318 6.6665 6.66602 7.26367 6.66602 8.00031C6.66602 8.73696 7.26318 9.33412 7.99983 9.33412Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99954 3.06533C10.9339 3.02398 13.8596 5.07538 15.6236 7.01608C16.1247 7.57508 16.1256 8.42142 15.6256 8.98144C13.8803 10.9021 10.9966 12.9355 8.09757 12.9355H7.89216C5.00313 12.9355 2.11877 10.9021 0.375479 8.98211C-0.12516 8.42238 -0.12516 7.57581 0.375479 7.01608C2.13944 5.07605 5.06515 3.02332 7.99954 3.06533ZM7.99954 4.93267C6.30526 4.93267 4.93177 6.30616 4.93177 8.00044C4.93177 9.69471 6.30526 11.0682 7.99954 11.0682C9.69381 11.0682 11.0673 9.69471 11.0673 8.00044C11.0673 6.30616 9.69381 4.93267 7.99954 4.93267Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.94bb876a26f1d709d2052ec9f29c321a.svg";
export { ForwardRef as ReactComponent };